import React from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";
import MaskedInput from "react-text-mask";

import BodyText from "Common/BodyText";
import { Span } from "Common/HTML";

import makeBem from "Utils/makeBem";

const bem = makeBem("SIFormTinyInput");

class SIFormTinyInput extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate(oldProps: Props) {
    if (this.maskedInput && (this.props.input && this.props.input.value) !== (oldProps.input && oldProps.input.value)) {
      // MaskedInput doesn't allow updating the value using props (it treats
      // value as initialValue), so we manually update the value (and validate
      // it against the mask) when it would change.
      this.maskedInput.inputElement.value = this.props.input ? this.props.input.value : "";
      this.maskedInput.textMaskInputElement.update();
    }
  }

  render() {
    const { size, disabled, label, className, mask, meta, input, ...rest } = this.props;
    const classes = classnames(bem(), className, {
      [bem(null, "intuit")]: isIntuit(),
      [bem(null, "error")]: meta && meta.touched && meta.error,
    });
    return (
      <BodyText
        className={classnames(bem(), {
          [bem(null, "disabled")]: disabled,
          [bem(null, "intuit")]: isIntuit(),
        })}
        disabled={disabled}
        {...rest}
      >
        <MaskedInput ref={(e) => (this.maskedInput = e)} className={classes} disabled={disabled} size={size} mask={mask} {...input} {...rest} />
        {label && (
          <Span
            className={classnames(bem("Label"), {
              [bem("Label", "intuit")]: isIntuit(),
            })}
            pl={3}
          >
            {label}
          </Span>
        )}
      </BodyText>
    );
  }
}

SIFormTinyInput.defaultProps = {
  disabled: false,
  options: {
    Yes: "Yes",
    No: "No",
  },
  input: {},
  size: 4,
  mask: false,
};
export default SIFormTinyInput;
